import { useCallback, useRef, useState } from "react";
import "../ReportTable.css";
import { useLayoutEffect, useEffect } from "react";
import ApiHandler from "../../ApiHandler";
import "./Company.css";
import { Table } from "react-bootstrap";
import * as XLSX from "xlsx";
import format from "date-fns/format";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import {
  clearSelectedClient,
  fetchGroupClients,
  getSelectedClientId,
  setSelectedClient,
} from "../../ClientSelection";
import TransferData from "../../TransferData";
import dayjs from "dayjs";
import img2 from "./img2.png";
import RelysoftLink from "../RelysoftLink";
import { Link } from "react-router-dom";

import { DatePicker } from "antd";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import LoaderTri from "../Loader/LoaderTri";
import { userActions } from "../../store/user-slice";
import { useDispatch } from "react-redux";
import { useDownloadExcel } from "react-export-table-to-excel";
import { dateOnly } from "../../dateOnly";
import ReportExport from "../ReportExport";

// The report list (and each endPoint) comes from the server per client, so this
// must not be an exact-string compare - casing and path have both changed
// between API versions (api/ownapp/GetStockandsale -> StockAndSales/StockAndSale).
const isStockAndSaleReport = (endPoint) =>
    typeof endPoint === "string" &&
    endPoint.toLowerCase().replace(/[^a-z]/g, "").includes("stockandsale");

const initialValues = {
  from: dayjs(),
  to: dayjs(),
};
export default function CompanyDashboard(e) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showList, setShowList] = useState([]);
  const [reportsData, setReportsData] = useState([]);
  const [selectedData, setSelectedData] = useState("");
  const [selectedOrderData, setSelectedOrderData] = useState([]);
  const [selectedCompPenClaim, setSelectedCompPenClaim] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [hideBorders, setHideBorders] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [range, setRange] = useState([
    {
      startdate: new Date(),
      endDate: addDays(new Date(), ""),
      key: "selection",
    },
  ]);
  const [companyCode, setCompanyCode] = useState(null);
  const [dates, setDates] = useState(initialValues);
  const [hideElement, setHideElement] = useState(false);

  const [alldatesData, setAlldatesData] = useState([]);
  const [selectedStocksandSales, setSelectedStocksandSales] = useState([]);
  const [selectedStocksandSalesFOOTER, setSelectedStocksandSalesFOOTER] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownSelected, setDropdownSelected] = useState(false);

  const refOne = useRef(null);
  const customerName = JSON.parse(localStorage.getItem("user-info"));

  const formatDate = (date) => {
    return date ? format(new Date(date), "dd-MM-yyyy") : ""; // Format the date as "DD-MM-YYYY", handle null or undefined case
  };
  // after click, it will be false
  useEffect(() => {
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("keydown", hideOnEscape, true);
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, []);

  const hideOnEscape = (e) => {
    console.log(e.key);
    if (e.key === "Escape") {
      setOpenDate(false);
    }
  };
  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpenDate(false);
    }
  };

  const [localUrl_new, setLocalUrl_new] = useState("");

  // Firm picker, scoped to this screen only. Reports are per firm:
  // CompanyLoginConfig is keyed on wClientid and each firm has its own
  // localUrl, so switching firm refetches the company list, the report list
  // and that localUrl together. The choice is stored for the company screens
  // only - GlobalVariable.wcClient stays 5811997, so the customer side is
  // unaffected by what a rep picked here.
  const [firmClients, setFirmClients] = useState([]);
  // Defaults to the firm the rep signed in against.
  const [firmId, setFirmId] = useState(getSelectedClientId());

  useEffect(() => {
    fetchGroupClients()
      .then((list) => {
        setFirmClients(list);
        // Keep the login firm when it is still in the group, else fall back.
        if (!list.some((c) => c.wClientId === firmId) && list.length) {
          setFirmId(list[0].wClientId);
        }
      })
      .catch((err) => {
        console.error("Could not load the firm list", err);
        toast.error("Could not load the firm list");
      });
    // Runs once on mount; firmId is only read to decide the fallback.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // company names + report list + local url, for the selected firm
  const loadFirmConfig = useCallback(() => {
    const user = JSON.parse(localStorage.getItem("user-info"));

    if (user && firmId) {
      ApiHandler.post({
        url: "/api/OwnAppConfigs/CompanyLoginConfig/",

        data: {
          wClientid: firmId,
          repCode: user.code,
        },
      })
        .then((result) => {
          setReportsData(result.data.reports || []);
          setShowList(result.data.companies || []);
          setLocalUrl_new(result.data.localUrl);
        })
        .catch((err) => {
          console.error(err);
          if (
            err.response &&
            err.response.status &&
            err.response.status === 401
          ) {
            console.log(err.response);
            //   RefreshTokenHandler();
            //  ToastError("Token has expired Please refresh");
          }
          // The token is issued for one client. If the API refuses this firm,
          // say so rather than leaving empty dropdowns with no explanation.
          setReportsData([]);
          setShowList([]);
          setLocalUrl_new("");
          toast.error("Could not load reports for this firm");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firmId]);

  useEffect(() => {
    loadFirmConfig();
  }, [loadFirmConfig]);

  const handleFirmChange = (e) => {
    const id = e.target.value;
    if (!firmClients.some((c) => c.wClientId === id)) return;

    // Store it so the reports' localUrl follows the firm, then let
    // loadFirmConfig re-run on firmId for this firm's companies and reports.
    const client = firmClients.find((c) => c.wClientId === id);
    if (client) setSelectedClient(client);
    setFirmId(id);

    // Anything on screen belongs to the previous firm.
    setCompanyCode(null);
    setSelectedData("");
    setShowResults(false);
    setSelectedOrderData([]);
    setReportsData([]);
    setShowList([]);
  };

  // to get data after selection category

  const getData = useCallback(
    (elm, date) => {
      setIsLoading(true);

      const user = JSON.parse(localStorage.getItem("user-info"));
      const localUrl = JSON.parse(localStorage.getItem("LocalURL"));
      if (!companyCode) {
        setIsLoading(false);
        toast.error("Company Code not Found");
        return;
      }
      if (!localUrl_new) {
        setIsLoading(false);
        toast.error("No server configured for this firm");
        return;
      }

      ApiHandler.post({
        url: localUrl_new + elm + "/",
        data: {
          startdate: dayjs(dates.from).format("YYYYMMDD"),
          enddate: dayjs(dates.to).format("YYYYMMDD"),
          code: companyCode,
          // startdate: "20210101",
          // enddate: "20230502",
          // code: user.code,
        },
        useUserUrl: true,
      })
        .then((result) => {
          console.log(result);
          console.log(result.data);
          setAlldatesData(result.data);
          setSelectedOrderData(result.data);
          setSelectedStocksandSales(result.data.stockAndSaleDetails);
          setSelectedStocksandSalesFOOTER(result.data.footer);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
          if (
            err.response &&
            err.response.status &&
            err.response.status === 401
          ) {
            console.log(err.response);
            //   RefreshTokenHandler();
            //  ToastError("Token has expired Please refresh");
          }
        });
    },
    [companyCode, dates, localUrl_new]
  );

  // log out function

  function logout() {
    window.localStorage.removeItem("user-info");
    window.localStorage.removeItem("app-type");
    // Drop the firm choice and its localUrl so the next login starts clean.
    clearSelectedClient();
    dispatch(userActions.setLogin(false));

    history.push("/");
  }

  const orderTableRef = useRef();
  const stockTableRef = useRef();

  function handleExportDataExcelOrders() {
    const company = showList.find((c) => c.comCode === parseFloat(companyCode));
    const report = reportsData.find((c) => c.endPoint === selectedData);

    const siteName = JSON.parse(localStorage.getItem("user-info"));
    var Heading = [
      [siteName.clientName],
      ["Company Name: " + company?.companyName],
      [
        "Report: " +
        report?.reportName +
        ", " +
        dates.from.format("DD-MM-YYYY") +
        " - " +
        dates.to.format("DD-MM-YYYY"),
      ],
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
    ];
    ws["!cols"] = [{ width: 30 }];
    XLSX.utils.sheet_add_aoa(ws, Heading);

    // XLSX.utils.sheet_add_json(ws, selectedOrderData, {
    //   origin: "A4",
    //   // skipHeader: true,
    // });

    // Add table headers
    const headers = Object.keys(selectedOrderData[0]).map(
      (data) => TransferData[data] || data
    );
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });

    // Add order data
    const orderData = selectedOrderData.map((order) => Object.values(order));
    XLSX.utils.sheet_add_aoa(ws, orderData, { origin: "A5" });

    XLSX.utils.book_append_sheet(wb, ws, sheetName("Report"));
    XLSX.writeFile(wb, exportFileName("Report") + ".xlsx");
  }

  function handleExportDataExcelStockandSales() {
    const company = showList.find((c) => c.comCode === parseFloat(companyCode));
    const report = reportsData.find((c) => c.endPoint === selectedData);

    const siteName = JSON.parse(localStorage.getItem("user-info"));

    var Heading = [

      [siteName.clientName],
      ["Company Name: " + company?.companyName],
      [
        "Report: " +
        report?.reportName +
        ", from " +
        dates.from.format("DD-MM-YYYY") +
        " - to " +
        dates.to.format("DD-MM-YYYY"),
      ],
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 16 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 16 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 16 } },
    ];
    ws["!cols"] = [{ width: 30 }];
    XLSX.utils.sheet_add_aoa(ws, Heading);

    // XLSX.utils.sheet_add_json(ws, selectedStocksandSales, {
    //   origin: "A4",
    //   // skipHeader: true,
    // });

    // Add table headers
    const headers = Object.keys(selectedStocksandSales[0]).map(
      (data) => TransferData[data] || data
    );
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });

    // Add order data
    const orderData = selectedStocksandSales.map((order) =>
      Object.values(order)
    );
    XLSX.utils.sheet_add_aoa(ws, orderData, { origin: "A5" });

    XLSX.utils.book_append_sheet(wb, ws, sheetName("Stock and Sale"));
    XLSX.writeFile(wb, exportFileName("Stock and Sale") + ".xlsx");
  }

  const handleSelects = (date) => {
    let filtered = alldatesData.filter((product) => {
      let productDate = new Date(product["orderDate"]);
      return (
        productDate >= date.selection.startDate &&
        productDate <= date.selection.endDate
      );
    });
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    // setSelectedOrderData(filtered);
    setSelectedStocksandSales(filtered);
    console.log(date.selection.startDate);
    console.log(date.selection.endDate);
  };

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  const handleDropdownChange = (e) => {
    setSelectedData(e.target.value);
    setDropdownSelected(true); // Update the dropdown selection state
  };

  const handleSubmit = () => {
    if (!dropdownSelected) {
      // Display error message if dropdown is not selected
      toast.error("Please select a report");
      return;
    }

    setSelectedOrderData([]);
    setSelectedCompPenClaim([]);
    setSelectedStocksandSales([]);
    setDisabled(true);
    getData(selectedData);
  };

  const checkViewportWidth = () => {
    const viewportWidth = window.visualViewport.width;
    if (viewportWidth < 600) {
      // Adjust the threshold as needed
      setHideElement(true);
    } else {
      setHideElement(false);
    }
  };

  useLayoutEffect(() => {
    checkViewportWidth();
    window.addEventListener("resize", checkViewportWidth);
    return () => {
      window.removeEventListener("resize", checkViewportWidth);
    };
  }, []);


  /* ---- what the downloads contain ----
     The orders report's columns come back with the response, so they are read
     off the first row; the stock-and-sale report always has the same fifteen.
     Both spreadsheets keep this page's own headed layout (the company, the
     report and the date range across the top) - only the PDF is new. */
  const isNumericColumn = (rows, key) =>
    rows.every((row) => {
      const value = row[key];

      if (value === null || value === undefined || value === "") {
        return true;
      }

      return !isNaN(Number(String(value).replace(/,/g, "")));
    });

  const orderExportColumns =
    Array.isArray(selectedOrderData) && selectedOrderData.length > 0
      ? Object.keys(selectedOrderData[0]).map((key) => ({
          key,
          label: TransferData[key] || key,
          align: isNumericColumn(selectedOrderData, key) ? "right" : undefined,
          wrap: /name|product|particular|remark|supplier/i.test(key),
          format: dateOnly,
        }))
      : [];

  const stockExportColumns = [
    { key: "flag", label: TransferData.flag },
    { key: "product_Name", label: TransferData.name, wrap: true },
    { key: "pack", label: TransferData.pack },
    { key: "rate", label: TransferData.rate, align: "right" },
    { key: "prevLastSale", label: TransferData.prevLastSale, align: "right" },
    { key: "prevSale", label: TransferData.prevSale, align: "right" },
    { key: "opening", label: TransferData.opening, align: "right" },
    { key: "receipt", label: TransferData.receipt, align: "right" },
    { key: "sales", label: TransferData.sales, align: "right" },
    { key: "salesRtn", label: TransferData.salesRtn, align: "right" },
    { key: "saleValue", label: TransferData.saleValue, align: "right" },
    { key: "purRtn", label: TransferData.purRtn, align: "right" },
    { key: "others", label: TransferData.others, align: "right" },
    { key: "closing", label: TransferData.closing, align: "right" },
    { key: "cl_Value", label: TransferData.cl_Value, align: "right" },
  ];

  // File name for every export on this screen (Excel and PDF):
  //   "<Report> - <Company> - <from> to <to>"
  // (Was a fixed Reports.xlsx / report.pdf whatever the report.)
  // Characters Windows refuses in a file name are dropped.
  const exportFileName = (fallback = "Report") => {
    const company = showList.find((c) => c.comCode === parseFloat(companyCode));
    const report = reportsData.find((c) => c.endPoint === selectedData);
    const parts = [
      (report && report.reportName) || fallback,
      company && company.companyName,
      dates.from.format("DD-MM-YYYY") + " to " + dates.to.format("DD-MM-YYYY"),
    ].filter(Boolean);
    return parts
      .join(" - ")
      .replace(/[\\/:*?"<>|]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 150);
  };

  // Excel sheet tab: the report name (max 31 characters, none of []:*?/\).
  const sheetName = (fallback = "Report") => {
    const report = reportsData.find((c) => c.endPoint === selectedData);
    const name = ((report && report.reportName) || fallback)
      .replace(/[[\]:*?/\\]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 31);
    return name || fallback;
  };

  const exportSubtitle = () => {
    const company = showList.find((c) => c.comCode === parseFloat(companyCode));
    const report = reportsData.find((c) => c.endPoint === selectedData);

    return [
      company ? "Company: " + company.companyName : "",
      report ? report.reportName : "",
      dates.from.format("DD-MM-YYYY") + " to " + dates.to.format("DD-MM-YYYY"),
    ];
  };

  return (
    <>
      {/* Deliberately not using .product_header / #S / .R from App.css: those
          float the partner logo with negative margins and squash the square
          brand mark to 70x80, which is what made this header look broken.
          These classes are local to Company.css. */}
      {/* Was a Bootstrap row of col-3 / col-9 / col-5, which left the name
          hard against the logo. Three grid columns with matching outer widths
          put the NAME on the true centre of the band while the logo keeps its
          place on the left. The
          "Pharmaceutical Distributor" line has been dropped. */}
      <header className="companyHeader">
        <Link to="/" className="companyLogoLink">
          <img src={img2} className="companyLogo" alt="Sarvodaya Group" />
        </Link>

        <Link to="/" className="companyBrand">
          <span>
            <h1 className="companyTitle mb-0">SARVODAYA GROUP</h1>
            <div className="companySince">Since 1999</div>
          </span>
        </Link>

        <div className="companyMeta">
          <RelysoftLink className="companyPartnerLogo" />
          <div className="companyUser">
            {customerName?.name ? (
              <>Hello, <strong>{customerName.name}</strong></>
            ) : null}
          </div>
          <button className="customButton" onClick={logout}>
            Log out
          </button>
        </div>
      </header>

      <div className="row mx-0">
        <div className="col-lg-3 offset-lg-1 mb-2">
          <select
            className="form-control"
            value={firmId}
            onChange={handleFirmChange}
            disabled={firmClients.length === 0}
            style={{ borderColor: "#00A759", fontWeight: 600 }}
          >
            <option value="">
              {firmClients.length === 0 ? "Loading firms..." : "Select Firm"}
            </option>
            {firmClients.map((c) => (
              <option value={c.wClientId} key={c.wClientId}>
                {c.firmName}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-3 mb-2">
          <select
            className="form-control "
            value={companyCode ? companyCode : ""}
            onChange={(e) => {
              setCompanyCode(e.target.value);
              setDisabled(false);
              setShowResults(e.target.value === "" ? false : true);
            }}
          >
            <option value={""}>Select Company Name</option>
            {showList.map((P, i) => {
              return (
                <option value={P.comCode} key={i}>
                  {P.companyName}
                </option>
              );
            })}
          </select>
        </div>
        {showResults && (
          <>
            <div className="offset-lg-6"></div>
            <div className="col-lg-3 offset-lg-1 mb-2">
              <select
                value={selectedData}
                className="form-control"
                onChange={handleDropdownChange}
              >
                <option value={""}>Select Report</option>
                {reportsData.map((elm, i) => {
                  return (
                    <option key={i} value={elm.endPoint}>
                      {elm.reportName}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-lg-3 mb-2">
              {
                <DatePicker.RangePicker
                  format={"DD-MM-YYYY"}
                  size="large"
                  value={[dates.from, dates.to]}
                  onChange={(e) => {
                    console.log(e);

                    if (e) {
                      setDates({
                        from: e[0],
                        to: e[1],
                      });
                    } else {
                      setDates({ from: null, to: null });
                    }
                  }}
                />
              }
            </div>
            <div className="col-lg-2 text-center">
              <button
                type="button"
                className="submit_selectedData mb-2"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
            {/* col-3, so the row still totals twelve with the offset, the
                two selects and the submit button */}
            <div className="col-lg-3 text-center">
              {/* ONE export bar, for the report that is selected. Both used
                  to render at once, so Excel and PDF showed up twice. */}
              {isStockAndSaleReport(selectedData) ? (
              <ReportExport
                title={
                  (reportsData.find((c) => c.endPoint === selectedData) || {})
                    .reportName || "Stock and Sale"
                }
                subtitle={exportSubtitle()}
                columns={stockExportColumns}
                rows={selectedStocksandSales || []}
                fileName={exportFileName("Stock and Sale")}
                onExcel={handleExportDataExcelStockandSales}
              />
              ) : (
              <ReportExport
                title={
                  (reportsData.find((c) => c.endPoint === selectedData) || {})
                    .reportName || "Report"
                }
                subtitle={exportSubtitle()}
                columns={orderExportColumns}
                rows={selectedOrderData || []}
                fileName={exportFileName("Report")}
                onExcel={handleExportDataExcelOrders}
              />
              )}
            </div>
          </>
        )}
      </div>

      <div className="comp_data">
        {/* The scroll box owns both axes: the header row sticks to the top
            and the identifying column sticks to the left, so a phone user
            scrolling sideways still knows which row they are reading. */}
        <div className="rptScroll">
          {Array.isArray(selectedOrderData) && selectedOrderData.length > 0 && (
            <div className="p-2">
              <Table striped ref={orderTableRef} className="rptTable">
                <thead className="threAd">
                  <tr className="threAd_tr">
                    {Object.keys(selectedOrderData[0]).map((data, ii) => {
                      return (
                        <th key={ii}>
                          {TransferData[data] || data}
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                {selectedOrderData.map((data, i) => {
                  return (
                    <tbody key={i}>
                      <tr>
                        {Object.keys(selectedOrderData[0]).map((el, ii) => {
                          return (
                            <td key={ii}>
                              {/* the order rows are printed straight from the
                                  response, so any date column arrives as a
                                  full timestamp - the time is trimmed here */}
                              {dateOnly(data[el])}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  );
                })}
              </Table>
              <p className="rptHint">
                Swipe the table sideways - the first column stays put.
              </p>
            </div>
          )}

          {isStockAndSaleReport(selectedData) && (
            <div className="Data p-2">
              <Table
                striped
                ref={stockTableRef}
                className="rptTable rptTableStock"
              >
                <thead className="threAd">
                  <tr className="threAd_tr">
                    <th>{TransferData.flag}</th>
                    <th>{TransferData.name}</th>
                    <th>{TransferData.pack}</th>
                    <th>{TransferData.rate}</th>
                    <th>{TransferData.prevLastSale}</th>
                    <th>{TransferData.prevSale}</th>
                    <th>{TransferData.opening}</th>
                    <th>{TransferData.receipt}</th>
                    <th>{TransferData.sales}</th>
                    <th>{TransferData.salesRtn}</th>
                    <th>{TransferData.saleValue}</th>
                    <th>{TransferData.purRtn}</th>
                    <th>{TransferData.others}</th>
                    <th>{TransferData.closing}</th>
                    <th>{TransferData.cl_Value}</th>
                  </tr>
                </thead>

                <tbody className="tboDY">
                  {Array.isArray(selectedStocksandSales) &&
                    selectedStocksandSales.map((items, i) => {
                      return (
                        <tr key={i}>
                          <td>{items.flag}</td>
                          <td>{items.product_Name}</td>
                          <td>{items.pack}</td>
                          <td>{items.rate}</td>
                          <td>{items.prevLastSale}</td>
                          <td>{items.prevSale}</td>
                          <td>{items.opening}</td>
                          <td>{items.receipt}</td>
                          <td>{items.sales}</td>
                          <td>{items.salesRtn}</td>
                          <td>{items.saleValue}</td>
                          <td>{items.purRtn}</td>
                          <td>{items.others}</td>
                          <td>{items.closing}</td>
                          <td>{items.cl_Value}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              {isLoading && (
                <div className="d-flex justify-content-center align-items-center">
                  <LoaderTri />
                </div>
              )}
              <p className="rptHint">
                Swipe the table sideways - the flag and product columns stay
                put.
              </p>
              <h5 className="rptNotesHead">NOTES</h5>
            </div>
          )}
        </div>
        <div className="p-2">
          {Array.isArray(selectedStocksandSalesFOOTER) &&
            selectedStocksandSalesFOOTER.map((aa, i) => {
              return (
                <li key={i} className="Stock_Footer_Notes">
                  {aa.notes}
                </li>
              );
            })}
        </div>
      </div>
    </>
  );
}
